
import {Component, Prop, Vue} from "vue-property-decorator";
import ErrorIcon from "./ErrorIcon.vue";
import ErrorMessage from "@/components/molecules/ErrorMessage";
import {CreateElement, VNode} from "vue";
import {isString} from "@/utils/TypeUtil";

@Component
class MessageRenderer extends Vue {
  @Prop({
    type: [String, Object, Array]
  })
  private message!: ErrorMessage['message'];

  @Prop({
    type: Boolean,
    default: false,
  })
  private small!: boolean;

  render(h: CreateElement) {
    const children = (() => {
      if(isString(this.message)) {
        return [this.message];
      } else if(Array.isArray(this.message)) {
        return this.message;
      } else {
        return [this.message];
      }
    })();

    return h('span', {
      class: {
        'message-renderer': true,
        small: this.small
      }
    }, children);
  }
}

@Component({
  components: {ErrorIcon, MessageRenderer},
})
export default class ErrorPanel extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  private errors!: ErrorMessage[];

  @Prop({
    type: Boolean,
    default: false,
  })
  private small!: boolean;
}
